import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { getTranslatation } from '../../locales/translate'
import { withRouter } from '../../components/funcs/BASES/withRouter'

import { TableOne } from '../../components/lib/table'
import { Cols } from '../../components/features/TableCols/BeslenmeCategory'
import { FaSearch, FaPlus } from 'react-icons/fa'
import { InputOne } from '../../components/lib/input'
import { IconButton } from '../../components/lib/button'
import { GridBlock } from '../../components/lib/grid'
import { ParallaxCard } from '../../components/lib/cards'

import endPoints from '../../components/Consts/endPoints.json'
import * as BeslenmeCategoryActions from '../../redux/actions/BeslenmeCategory'


class BeslenmeCategory extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loginOnProcess: false,
      searchWord: ''
    }
    this.releatedRoutes = endPoints.find(aa => aa.name == 'BeslenmeCategory')?.routes
  }

  componentDidMount () {
    this.props.actions.GetAll(
      null,
      () => {
        this.setState({ loginOnProcess: false })
      },
      () => {
        setTimeout(() => {
          this.setState({ loginOnProcess: false })
        }, 1000)
      },
      () => {},
      () => {}
    )
  }

  setVal = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  update = id => {
    this.props.router.navigate(this.releatedRoutes.create, {
      replace: true,
      state: { id }
    })
  }

  filteredData = () => {
    let data = this.props.BeslenmeCategoryReducers?.All || []
    if (this.state.searchWord.length > 0) {
      data = data.filter(item => {
        return item?.beslenmeCategory_text?.toLowerCase().includes(this.state.searchWord.toLowerCase())
      })
    }
    return data
  }

  render () {
    return (
      <GridBlock style={{ padding: 10 }}>
        <TableOne
          title={'Beslenme Kategorileri'}
          responsive={true}
          subHeader={true}
          columns={Cols(this.update)}
          data={this.filteredData()}
          pagination={true}
          subHeaderComponent={
            <GridBlock container justify={'space-between'} align={'space-between'} style={{ padding: 10 }}>
              <IconButton
                icon={<FaPlus />}
                onClick={() => {
                  this.props.router.navigate(this.releatedRoutes.create)
                }}
              />

              <InputOne
                color={'success'}
                variant='filled'
                margin='none'
                required
                fullWidth
                xs={10}
                sm={6}
                lg={4}
                id='searchWord'
                label={'Arama Yap'}
                maskPlaceholder={'Arama Yap'}
                name='searchWord'
                value={this.state.searchWord}
                onChange={this.setVal}
                helperText={'Kategori adına göre arama yapınız'}
                endAdornment={<FaSearch />}
              />
            </GridBlock>
          }
        />

        <ParallaxCard
          imageOne={require('../../asserts/images/cards/yoga/extended2.png')}
          imageTwo={require('../../asserts/images/cards/flower4.png')}
          imageThree={require('../../asserts/images/cards/flowers3.png')}
          imageFour={require('../../asserts/images/cards/flower.png')}
        />
      </GridBlock>
    )
  }
}

function mapStateToProps (state) {
  return {
    BeslenmeCategoryReducers: state.BeslenmeCategoryReducers
  }
}

function mapDispatchToProps (dispatch) {
  return {
    actions: {
      GetAll: bindActionCreators(BeslenmeCategoryActions.GetAll, dispatch),
    }
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BeslenmeCategory))
